import { Controller, useWatch } from 'react-hook-form';
import { CreatorApprovedSwapsForm } from '@client/new/features/exercise-swaps';
import { EditWorkoutVM } from '../view-models/workoutEdit.viewModel';

type SwapFieldPath =
  | `exercises.${number}`
  | `exercises.${number}.exercises.${number}`;

// Thin adapter wiring the self-contained exercise-swaps feature into the
// legacy RHF workout form. All swap behavior lives in the feature slice.
export const CreatorApprovedSwapsField = (p: {
  control: EditWorkoutVM['control'];
  influencerId: number;
  fieldPath: SwapFieldPath;
  disabled?: boolean;
}) => {
  const programId = useWatch({ control: p.control, name: 'programId' });
  const workoutSwapsEnabled = useWatch({
    control: p.control,
    name: 'swapsEnabled',
  });
  const exerciseName = useWatch({
    control: p.control,
    name: `${p.fieldPath}.name`,
  });
  const exerciseSets = useWatch({
    control: p.control,
    name: `${p.fieldPath}.sets`,
  });
  if (!programId) return null;

  return (
    <Controller
      name={`${p.fieldPath}.swapConfig`}
      control={p.control}
      render={({ field }) => (
        <CreatorApprovedSwapsForm
          value={field.value}
          onChange={field.onChange}
          exerciseName={exerciseName ?? ''}
          exerciseSets={exerciseSets ?? []}
          influencerId={p.influencerId}
          programId={programId}
          workoutSwapsOff={workoutSwapsEnabled === false}
          unavailable={workoutSwapsEnabled === undefined}
          disabled={p.disabled}
        />
      )}
    />
  );
};
